import './testimonial-item.styles.scss';

const TestimonialItem = ({ image }) => {
  return (
    <div className='testimonial-container'>
      <div className='image-container'>
        <img src={image} alt='' />
      </div>
      <div className='content-container'>
        <p>
          “ Можливо після переохолодження, можливо на роботі, не знаю. В мене
          почало боліти у попереку, я подумала що защемила спину та не звертала
          особливохї уваги на біль і продовжувала працювати. Але через кілька
          днів в мене з’явилася температура і це мене вже насторожило. Я
          спиталася у знайомих і вони мені порадили звернутися до Сергія
          Сергійовича. Він виявився дуже уважним та призначив мені діагностику
          та лікування, після цього я видужала. Як виявилось це була зовсім не
          спина. Дякую Вам, тепер я можу знов повноцінно працювати!”
        </p>
        <h3>Вікторія</h3>
        <h4>Пацієнтка</h4>
      </div>
    </div>
  );
};

export default TestimonialItem;
